import React, { useState } from 'react';
import './Admin.css';
import { useSearchParams } from 'react-router-dom';

function Admin() {
  const [name, setName] = useState('');
  const [minutes, setMinutes] = useState('');
  const [seconds, setSeconds] = useState('');
  const [searchParams] = useSearchParams();

  const handleSubmit = (e) => {
    e.preventDefault();
    //const url = `http://127.0.0.1:5001/ki2ne-games/us-central1/addscore2?name=${encodeURIComponent(name)}&minutes=${encodeURIComponent(minutes)}&seconds=${encodeURIComponent(seconds)}&key=${searchParams.get("key")}`;
    const url = `https://us-central1-ki2ne-games.cloudfunctions.net/addscore2?name=${encodeURIComponent(name)}&minutes=${encodeURIComponent(minutes)}&seconds=${encodeURIComponent(seconds)}&key=${searchParams.get("key")}`;
    const hiddenTab = document.createElement('a');
    hiddenTab.href = url;
    hiddenTab.target = '_blank';
    hiddenTab.style.display = 'none';
    document.body.appendChild(hiddenTab);
    hiddenTab.click();
    document.body.removeChild(hiddenTab);
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        Admin
      </header>
      <div className="admin-content">
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="minutes">Minutes:</label>
            <input
              type="number"
              id="minutes"
              value={minutes}
              onChange={(e) => setMinutes(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="seconds">Seconds:</label>
            <input
              type="number"
              id="seconds"
              value={seconds}
              onChange={(e) => setSeconds(e.target.value)}
              required
            />
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default Admin;